import React, { useState, useEffect, useRef } from "react";
import { usePFDataContext } from "../context/PfContext";
import { useSearchParams } from "react-router-dom"; // Use React Router to handle URL params

import BrandCategoryStrain from "./filters/BrandCategoryStrain";
import ThcPriceSlider from "./filters/ThcPriceSlider";
import Search from "./filters/Search";
import ProductListCta from "./ProductListCta";

const ProductFilters = () => {


    const { pfData, updatePfData } = usePFDataContext();
    const [searchParams, setSearchParams] = useSearchParams();

    // Function to update URL params when filters change
   // Function to update URL parameters
  const updateURLParams = () => {
    const params = new URLSearchParams();

    Object.entries(pfData.filter).forEach(([key, value]) => {
      if (Array.isArray(value) && value.length > 0) {
        params.set(key, JSON.stringify(value)); // Store array as JSON string
      } else if (typeof value === "string" && value.trim() !== "") {
        params.set(key, value);
      }
    });

    setSearchParams(params);
  };

  // Sync filters with URL when filters change
  useEffect(() => {
    updateURLParams();
  }, [pfData.filter]);


  return (
    <div className="product__listing-ctas">
      {/* Search */}
      
      <Search />

      {/* Filters */}
      <div className="pf__row flex__t-column flex__t-align-center">
        <div className="pf__product-filters flex flex__m-column flex__m-align-center">
            <BrandCategoryStrain />
        </div>
      </div>

      {/* Price and THC slider */}
      <div class="pf__row flex__t-column flex__t-align-center">
          <div class="filter__sliders">
              <ThcPriceSlider />
          </div>  
       </div> 

      <ProductListCta />
  
    </div>
  );
};


export default ProductFilters;
